import React, { Component } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  CardHeader,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import Heading from "./Heading";
import StaffList from "./StaffList";
import CreateStaffModal from "./CreateStaffModal";
import inviteImage from "../../files/invite.png";
import { USERS_ROLE } from "../../constants/role.constant";
const _ = require("lodash");
class Staff extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch({
      type: "DO_GET_ASSIGNED_USERS_LIST_NEW",
    });

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      modal: false,
      modal2: false,
      modalStaff: false,
      emailOffer: "",
      emailAccess: "",
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      showAlertSuccess: false,
      errorPassword: false,
      role: "",
      otherRole: undefined,
      isOtherRole: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleStaff = this.toggleStaff.bind(this);
    this.openInvite = this.openInvite.bind(this);
    this.submit = this.submit.bind(this);
    this.submitStaff = this.submitStaff.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.deleteInvitation = this.deleteInvitation.bind(this);
    this.userInputChange = this.userInputChange.bind(this);
    this.expectationInputChange = this.expectationInputChange.bind(this);
    this.handleRole = this.handleRole.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  handleKeyDown(e){
    const inputField = e.target;
    const inputValue = inputField.value;
    const caretPosition = inputField.selectionStart;
    if (e.keyCode === 32) {
      // Check if it's the first character and if there are no non-space characters before it
      if (caretPosition === 0 || /^\s+$/.test(inputValue.substring(0, caretPosition))) {
        e.preventDefault();
      }
    }
  };
  userInputChange(event, staffId) {
    const target = event.target;
    const isCheck = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (isCheck) {
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
        payload: { staffId: staffId, isAdd: true, users: [target.name] },
      });
    } else {
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_STAFF_PATIENT",
        payload: { staffId: staffId, isAdd: false, user: target.name },
      });
    }
    setTimeout(() => {
      this.props.dispatch({
        type: "DO_GET_STAFF",
      });
    }, 500);
    // this.setState({
    //   [name]: value
    // });
  }
  expectationInputChange(event, staffId, expectation) {
    const target = event.target;
    const isCheck = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (isCheck) {
      
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_EXPECTATION",
        payload: {
          staffId: staffId,
          isAdd: true,
          expectationId: expectation._id,
          expectationType: expectation.ruleType,
        },
      });
    } else {
      this.props.dispatch({
        type: "DO_ADD_OR_DELETE_EXPECTATION",
        payload: {
          staffId: staffId,
          isAdd: false,
          expectationId: expectation._id,
          expectationType: expectation.ruleType,
        },
      });
    }
    setTimeout(() => {
      this.props.dispatch({
        type: "DO_GET_STAFF",
      });
    }, 500);
    // this.setState({
    //   [name]: value
    // });
  }
  handleRole(e){
    if(e.target.name != 'otherRole'){
      this.setState({ role: e.target.value, otherRole: undefined });
      return;
    }
    if(this.state.role == 'Other' && e.target.name == 'otherRole'){
      this.setState({ otherRole: e.target.value });
    }else if(this.state.role != 'Other' && e.target.name != 'otherRole'){
      this.setState({ otherRole: undefined });
    }
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
    if (name === "confirmpassword") {
      const checkMatch = this.state.password === value;

      if (!checkMatch) {
        this.setState({ errorPassword: true });
      } else {
        this.setState({ errorPassword: false });
      }
    }
  }
  resetForm() {
    this.setState({
      modal2: false,
      modal: false,
      modalStaff: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      role: "",
      otherRole: undefined
    });
    this.props.dispatch({
      type: "GENERIC_ERROR",
    });
    this.props.dispatch({
      type: "DO_GET_STAFF",
    });
  }
  toggleModal() {
    
    this.setState({
      modal: !this.state.modal,
    });
  }
  toggleStaff() {
    
    this.setState({
      modalStaff: !this.state.modalStaff,
    });
  }
  openInvite() {
    
    this.setState({
      modal2: !this.state.modal2,
    });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  deleteInvitation(id) {
    this.props.dispatch({
      type: "DO_DELETE_STAFF",
      payload: { id: id },
    });
    setTimeout(() => {
      this.props.dispatch({
        type: "DO_GET_STAFF",
      });
    }, 500);
  }
  groupByUser() {
    var result = _.chain(this.props.pmRecords)
      .groupBy("patient._id")
      .map((trackTime, userId) => ({ trackTime, userId }))
      .value();
    return result;
  }
  submit(e) {
    e.preventDefault();

    this.props.dispatch({
      type: "DO_SEND_INVITE",
      payload: {
        fname: this.state.fname,
        lname: this.state.lname,
        email: this.state.email,
        isStaff: true,
        isCareProvider: false,
        role: this.state.role != 'Other' ? this.state.role : this.state.otherRole,
        isOtherRole: this.state.role != 'Other' ? false : true,
      },
    });
  }
  submitStaff(e) {
    e.preventDefault();
    this.setState({
      role: this.state.role != 'Other' ? this.state.role : this.state.otherRole,
      isOtherRole: this.state.role != 'Other' ? false : true,
    }, () => {  
    const cleanStaff = _.omit(this.state, [
      "activeTab",
      "modal",
      "modal2",
      "modalStaff",
      "emailOffer",
      "confirmpassword",
      "emailAccess",
      "showAlertSuccess",
      "errorPassword",
      "otherRole"
    ]);
    this.props.dispatch({
      type: "DO_SAVE_STAFF",
      payload: cleanStaff,
    });
    setTimeout(() => {
      if (this.props.isClient) {
        this.props.dispatch({
          type: "DO_GET_STAFF",
          payload: { isClient: true, isAll: true },
        });
      } else {
        this.props.dispatch({
          type: "DO_GET_STAFF",
        });
      }

      // this.setState({
      //   modal2: false,
      //   modal: false,
      //   modalStaff: false,
      //   fname: "",
      //   lname: "",
      //   email: "",
      //   username: "",
      //   role: ""
      // });
    }, 400);
  });
  }
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
    this.props.dispatch({
      type: "GENERIC_ERROR",
    });
    if (!this.props.isClient) {
      this.props.dispatch({
        type: "DO_GET_STAFF",
      });
      this.props.dispatch({
        type: "DO_GET_MY_RULES",
      });
    }
  }

  render() {
    let staffData;
    if (this.props.isClient) {
      staffData = this.props.clientStaff;
    } else {
      staffData = this.props.staff;
    }
    const onlyActivePatients = _.orderBy(
      _.filter(this.props.assignedUsersList, "isActive"),
      "fname",
      "asc"
    );
    const roleOptions = USERS_ROLE.filter((item) => item.type == "Staff" && item.value != 'Shared/Family Account');
    return (
      <div>
        <div className="row">
          {this.props.isAll && (
            <Heading
              title="STAFF/SUBUSER LIST"
              description=""
              backbutton="d-none"
              mainbutton="d-none"
              toggleModal={this.toggleModal}
            >
              <span className="page-title-icon bg-gradient-danger   text-white mr-2">
                <i className="mdi mdi-account-convert" />
              </span>
            </Heading>
          )}
          {!this.props.isAll && (
            <Heading
              title={null}
              description=""
              backbutton="d-none"
              mainbutton="d-block"
              toggleModal={this.toggleModal}
            >
              <span className="page-title-icon bg-gradient-danger   text-white mr-2">
                <i className="mdi mdi-account-convert" />
              </span>
            </Heading>
          )}

          <div className="col-12 grid-margin">
            <div className="card">
              <Nav tabs className="justify-content-center">
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === "1",
                    })}
                    onClick={() => {
                      this.toggle("1");
                    }}
                  >
                    STAFF
                  </NavLink>
                </NavItem>
              </Nav>
              <div className="card-body project-tab pt-2">
                <Row>
                  <Col sm="12" className="grid-margin mt-4">
                    {staffData && (
                      <StaffList
                        usersOfferedAccess={onlyActivePatients}
                        expectations={this.props.myRules}
                        deleteInvitation={this.deleteInvitation}
                        staff={staffData}
                        userInputChange={this.userInputChange}
                        expectationInputChange={this.expectationInputChange}
                        ongoingAssignedUsersListsRequest={this.props.ongoingAssignedUsersListsRequest}
                      />
                    )}
                    {/* {this.props.pmRecords && (
                      <CCMList
                        pmRecords={this.groupByUser()}
                        userId={this.props.userId}
                      />
                    )} */}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleModal}>
            Create a New Staff
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <h5 className="text-center" />
            <div className="row">
              {this.props.isClient && (
                <div className="col-12">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.toggleStaff}
                  >
                    <img
                      src="https://img.freepik.com/free-vector/cute-doctor-couple_57812-25.jpg?size=338&ext=jpg"
                      style={{ height: "180px" }}
                    />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      CREATE A NEW STAFF ACCOUNT
                    </span>
                    <small>You will input everything</small>
                  </NavLink>
                </div>
              )}
              {!this.props.isClient && (
                <div className="col-12 col-md-6">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.openInvite}
                  >
                    <img src={inviteImage} style={{ height: "180px" }} />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      INVITE A USER
                    </span>
                    <small>Send a sign up link</small>
                  </NavLink>
                </div>
              )}
              {!this.props.isClient && (
                <div className="col-12 col-md-6">
                  <NavLink
                    className="text-center d-block"
                    onClick={this.toggleStaff}
                  >
                    <img
                      src="https://img.freepik.com/free-vector/cute-doctor-couple_57812-25.jpg?size=338&ext=jpg"
                      style={{ height: "180px" }}
                    />
                    <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                      CREATE A NEW STAFF ACCOUNT
                    </span>
                    <small>You will input everything</small>
                  </NavLink>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.modal2}
          toggle={this.openInvite}
          className={this.props.className}
        >
          <ModalHeader toggle={this.openInvite}>
            Send an invite link
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <Form onSubmit={this.submit}>
              <FormGroup>
                <Label for="exampleText">First Name</Label>
                <Input
                  type="text"
                  name="fname"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <FormGroup>
                <Label for="exampleText">Last Name</Label>
                <Input
                  type="text"
                  name="lname"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <FormGroup>
              <Label for="exampleText">Role *</Label>
              <select
                name="role"
                className="form-control"
                onChange={this.handleRole}
                required
              >
              <option value="">
                Select Role
              </option>
              {roleOptions.map((option) => (
                <option value={option.value}>{option.role}</option>
              ))}
              </select>
              </FormGroup>
              {(this.state.role == 'Other' || this.state.otherRole != undefined) && (
              <FormGroup>
                <Label for="exampleText">
                Other Role *
                </Label>
                <Input
                  type="text"
                  required={this.state.role == 'Other' ? true : false}
                  name="otherRole"
                  onChange={this.handleRole}
                  onKeyDown={this.handleKeyDown}
                />
              </FormGroup>
              )}
              <FormGroup>
                <Label for="exampleText">Email</Label>
                <Input
                  type="email"
                  name="email"
                  required={true}
                  onChange={this.handleInputChange}
                  rows={10}
                />
              </FormGroup>
              <button type="submit" className="btn btn-block btn-info">
                Send
              </button>
            </Form>
          </ModalBody>
        </Modal>
        <CreateStaffModal
          modalStaff={this.state.modalStaff}
          toggleStaff={this.toggleStaff}
          errorPassword={this.state.errorPassword}
          submitStaff={this.submitStaff}
          handleInputChange={this.handleInputChange}
          handleRole = {this.handleRole}
          role = {this.state.role}
          handleKeyDown = {this.handleKeyDown}
        />
        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={this.resetForm}
          confirmBtnBsStyle="info"
        >
          {!this.state.bday && (
            <div>
              Submitted Successfully Invitation is Sent to {this.state.email}
            </div>
          )}
          {this.state.bday && <div>Staff Created Successfully</div>}
        </SweetAlert>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR",
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
          Error Code: {this.props.genericErrorMessage.error}
        </SweetAlert>
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    pmRecords,
    staff,
    assignedUsersList,
    myRules,
    ongoingAssignedUsersListsRequest
  } = careprovider;
  const userId = user.userDetails._id;

  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    readingSubTypes,
    pmRecords,
    userId,
    staff,
    assignedUsersList,
    myRules,
    ongoingAssignedUsersListsRequest
  };
};

export default connect(mapStateToProps)(Staff);
